module.exports = __webpack_public_path__ + "img/bottom.58939932.png";